import React from "react";
import "./style.css";

import teamworkImg from "./assets/about-popup.png";

import icon1 from "./assets/stats-info-icon-1.png";
import icon2 from "./assets/stats-info-icon-2.png";
import icon3 from "./assets/stats-info-icon-3.png";

import bulb from "./assets/values-icon-1.png";
import star from "./assets/values-icon-2.png";
import shield from "./assets/values-icon-3.png";
import team from "./assets/values-icon-4.png";

import salesImg from "./assets/sales-onboarding.png";
import supportImg from "./assets/pay-support.png";
import settlementImg from "./assets/settlement.png";

const Hero = () => {
  return (
    <>
      {/* HERO SECTION */}
      <section className="hero-section">
        <div className="hero-content">
          <p className="hero-subtitle">
            Built for entrepreneurs, by entrepreneurs
          </p>

          <h1 className="hero-title">
            The platform built to help <br />
            businesses achieve their <br />
            ambitions faster
          </h1>
        </div>
      </section>

      {/* IMAGE SECTION */}
      <div className="image-wrapper">
        <img src={teamworkImg} alt="Teamwork" className="team-image" />
      </div>

      {/* STATS SECTION */}
      <section className="stats-section">
        <div className="stats-container">
          <div className="stat-box">
            <div className="stat-icon">
              <img src={icon1} alt="customers" />
            </div>
            <p className="stat-text">100K+ customers</p>
          </div>

          <div className="stat-box">
            <div className="stat-icon">
              <img src={icon2} alt="api" />
            </div>
            <p className="stat-text">2M+ API Request per Day</p>
          </div>

          <div className="stat-box">
            <div className="stat-icon">
              <img src={icon3} alt="funds" />
            </div>
            <p className="stat-text">1B+ Funds Transfer Monthly</p>
          </div>
        </div>
      </section>

      {/* VALUES SECTION */}
      <section className="values-section">
        <p className="values-subtitle">Our values</p>
        <h2 className="values-title">
          The principles that drive everything we do
        </h2>

        <div className="values-grid">
          {/* Card 1 */}
          <div className="value-card">
            <img src={bulb} alt="success" className="value-icon" />
            <div>
              <h3 className="value-heading">Industry-Leading Success Rate</h3>
              <p className="value-text">
                Omeswara’s secure, optimized payment infrastructure delivers one
                of the best success rates in the industry—ensuring reliable,
                fast, and seamless transactions every time.
              </p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="value-card">
            <img src={star} alt="accountability" className="value-icon" />
            <div>
              <h3 className="value-heading">Easy Accountability</h3>
              <p className="value-text">
                Our platform simplifies financial operations. From collections
                to withdrawals and settlements, Omeswara provides clear
                visibility and built-in GST-friendly reconciliation to make your
                accounting effortless.
              </p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="value-card">
            <img src={shield} alt="secure" className="value-icon" />
            <div>
              <h3 className="value-heading">Secure Payment Infrastructure</h3>
              <p className="value-text">
                Omeswara uses advanced 256-bit AES encryption (TLS 1.2) along
                with PCI DSS Level 1 compliant systems to ensure every
                transaction is protected with bank-grade security.
              </p>
            </div>
          </div>

          {/* Card 4 */}
          <div className="value-card">
            <img src={team} alt="teamwork" className="value-icon" />
            <div>
              <h3 className="value-heading">Teamwork That Delivers</h3>
              <p className="value-text">
                We believe in collaboration. Our dedicated teams for sales,
                onboarding, customer support, and settlements work together to
                give you a smooth and reliable experience.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* TEAMS SECTION */}
      <section className="teams-section">
        <p className="teams-subtitle">Our Teams</p>
        <h2 className="teams-title">Helping Your Business Grow Smoothly</h2>

        <div className="teams-grid">
          {/* CARD 1 */}
          <div className="team-card">
            <img src={salesImg} alt="Sales" className="team-image" />
            <h3 className="team-heading">Sales & Onboarding</h3>
            <p className="team-text">
              Fast and simple KYC combined with guided onboarding helps you
              activate your Omeswara account quickly and start accepting
              payments without delays.
            </p>
          </div>

          {/* CARD 2 */}
          <div className="team-card">
            <img src={supportImg} alt="Support" className="team-image" />
            <h3 className="team-heading">Support</h3>
            <p className="team-text">
              Our support specialists are available to assist with integrations,
              payments, platform usage, and settlements—ensuring you always get
              the help you need.
            </p>
          </div>

          {/* CARD 3 */}
          <div className="team-card">
            <img src={settlementImg} alt="Settlement" className="team-image" />
            <h3 className="team-heading">Settlement</h3>
            <p className="team-text">
              Our settlement experts ensure timely and accurate settlements,
              helping you maintain steady cash flow and business continuity.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
